/* eslint-disable no-unused-vars */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import {
  Box,
  Button,
  IconButton, List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Popover,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAt,
  faCircleInfo, faFax, faMobile, faPhone,
} from '@fortawesome/free-solid-svg-icons';
import {
  PhoneIcon,
  MobolePhoneIcon,
  FaxIcon,
  EmailIcon,
  LogoCiatIcon,
} from './icons';

const BoxInfo = styled.div`
    position: absolute;
    z-index: 10;
    right: 5%;
    top: 8%;
    background: white;
    border: 1px solid #DDE2E9;
    border-radius: 0.3rem;
    padding: 10px;
    width: 400px;
    border: 1px solid #37a0a7;
    box-shadow: 0 0 20px 8px rgba(0,0,0,0.16);
    ::before{
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        right: 55%;
        top: -30px;
        border: 15px solid;
        border-color: transparent #ffffff #ffffff transparent;
    }
`;
const InfoText = styled.span`
    color: #5f5b5b;
    font-size: 0.9em;
`;
const ContainerInfo = styled.div`
    display: grid;
    grid-template-columns: 10% 88%;
    grid-row-gap: 10px;
    padding: 10px;
    margin-top: 15px;
`;
const ContainerLogoLink = styled.div`
  display: flex;
  align-items: center;
`;
const LogoImg = styled.img`
  width: 50px;
`;
const FooterTextCompany = styled.span`
  font-size: 0.9em;
  font-weight: 700;
  color: #417eb1;
  max-width: 100%;
  margin-left: 10px;
`;
const ContainerShine = styled.a`
  position: relative;
  overflow: hidden;
`;
const rotate = keyframes`
  0% {
    transform: skewX(0deg) translateX(0px);
  }
  90% {
    transform: skewX(0deg) translateX(0px);
  }
  100% {
    transform: skewX(20deg) translateX(200px);
  }
`;
const Shine = styled.div`
  position: absolute;
  top: 0;
  left: -80px;
  height: 100px;
  width: 30px;
  background: rgba(255, 255, 255, 0.2);
  transform: skewX(20deg) translateX(0);
  animation: ${rotate} 10s linear infinite;
`;
const CloseButton = styled.button`
  border: none;
  background: none;
  color: #5f5f5f;
  align-self: flex-end;
  outline: none;
  padding-bottom: 0;
  line-height: 0.5;
  cursor: pointer;
  &:hover{
    color: black;
  };
`;

const primaryTypographyProps = {
  sx: {
    display: 'flex',
    flexDirection: 'column',
  },
};

const listIconSX = {
  minWidth: 60,
  justifyContent: 'center',
};

function InfoButton({ content, disabled }) {
  const [opened, setOpened] = useState(false);
  const ref = useRef();
  return (
    <>
      <IconButton
        ref={ref}
        onClick={() => setOpened((o) => !o)}
        disabled={disabled}
        color="primary"
        title={content}
      >
        <FontAwesomeIcon icon={faCircleInfo} />
      </IconButton>
      <Popover
        open={opened}
        anchorEl={ref.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setOpened(false)}
      >
        <Box sx={{ displa_y: 'flex', maxWidth: 400 }} id="aa">
          <List
            dense
            subheader={(
              <Button
                href="https://ciat.net.ua/uk/"
                target="_blank"
                startIcon={<img src={LogoCiatIcon} alt="ЦІАТ" height={50} />}
                color="primary"
                fullWidth
                size="large"
                variant="outlined"
              >
                Центр інформаційних та аналітичних технологій
              </Button>
            )}
          >
            <ListItem>
              <ListItemIcon sx={listIconSX}>
                <FontAwesomeIcon icon={faPhone} size="lg" />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={primaryTypographyProps}>
                <a href="tel:+380443640787">(044) 364-07-87</a>
                <a href="tel:+380443640784">(044) 364-07-84</a>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon sx={listIconSX}>
                <FontAwesomeIcon icon={faFax} size="lg" />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={primaryTypographyProps}>
                <a href="tel:+380444240434">(044) 424-04-34</a>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon sx={listIconSX}>
                <FontAwesomeIcon icon={faMobile} size="lg" />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={primaryTypographyProps}>
                <a href="tel:+380678254371">(067) 825-43-71</a>
                <a href="tel:+380678254372">(067) 825-43-72</a>
                <a href="tel:+380663821998">(066) 382-19-98</a>
                <a href="tel:+380508580759">(050) 858-07-59</a>
                <a href="tel:+380931708444">(093) 170-84-44</a>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon sx={listIconSX}>
                <FontAwesomeIcon icon={faAt} size="lg" />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={primaryTypographyProps}>
                <a href="mailto:buh@ciat.net.ua">buh@ciat.net.ua (бухгалтерія)</a>
                <a href="mailto:support@ciat.net.ua">support@ciat.net.ua (підтримка)</a>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Popover>
    </>
  );
}
InfoButton.propTypes = {
  content: PropTypes.string,
  disabled: PropTypes.bool,
};

InfoButton.defaultProps = {
  content: 'Інформація',
  disabled: false,
};

export default InfoButton;
